module.exports = __webpack_public_path__ + "img/irish-aid-logo.cd3f0299.png";